const permissionsConstantAr = {
  cms: 'إدارة المحتوى',
  user: 'إدارة المستخدمين',
  usersApproval: 'طلبات التسجيل',
  approvedDomains: 'النطاقات المعتمدة',
  administration: 'إدارة',
  systemSettings: 'إعدادات النظام',
  proposalRequest: 'طلبات عروض الأسعار',
  invoice: 'الإيصالات',
  orders: 'إدارة الطلبات',
  blogs: 'المدونات',
  dashboard: 'لوحة التحكم',
  news: 'الاخبار',
  pages: 'الصفحات',
  successStories: 'قصص النجاح',
  inventoryManagement: 'إدارة الوسائط المتعددة',
  featuredContent: 'المحتوى المعروض',
  ordersManagement: 'إدارة الطلبات',
  reports: 'التقارير',
  notifications: 'الإشعارات',
};

export default permissionsConstantAr;
